var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-button',{attrs:{"text":"","variant":"secondary"},on:{"click":function($event){return _vm.$router.push('/')}}},[_c('u-icon',{attrs:{"left":"","icon":"mdi-arrow-left"}}),_vm._v(" Вернуться назад ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }